// @ts-strict-ignore
import { removeWhitespaceAndSpecialChars } from '../components/helpers/commons'
import React from 'react'
import StatSnippet from '../components/platinum-modules/stat-snippet'
import { renderToString } from 'react-dom/server'

export const Statsmodule = (_, jsonBody) => {
  const props = JSON.parse(jsonBody)

  return renderToString(<StatSnippet jsonBody={props} twoCol={true} />)
}

const superscriptTag = (_, arg1, arg2) => {
  return `<a href='#${removeWhitespaceAndSpecialChars(
    arg2,
  )}' style="text-decoration: none;"><sup>${arg1}</sup></a>`
}

export const markdownParser = (text: String, containerName: string = '') => {
  const toHTML = text.split('\n').map((t) =>
    t
      .trim() // using trim method to remove whitespace
      .replace(/^### (.*$)/i, '<h3>$1</h3>') // h3 tag || markdown e.g ### This line will be converted into an H3 tag
      .replace(/^## (.*$)/i, '<h2>$1</h2>') // h2 tag || markdown e.g ## This line will be converted into an H2 tag
      .replace(/^# (.*$)/i, '<h2>$1</h2>') // h1 tag || even though this is supposed to be an h1 tag, we are converting it to be an h2 for SEO purposes
      .replace(/^> (.*$)/i, '<blockquote>$1</blockquote>') // <blockquote> tag || markdown e.g > my personal quote
      .replace(/^\* (.*$)/i, '<ul><li>$1</li></ul>') // <li> tag || markdown e.g * item 1
      .replace(/\|_(.*?)_\|/gi, '<u>$1</u>') // undeline text|| markdown e.g |_ Here is an example of bold text _|
      .replace(/<sup>(.*?)<\/sup>\((.*?)\)/i, superscriptTag) // style text|| markdown e.g <sup>text</sup>(https//:www.money.co.uk)
      .replace(/\*\*(.*?)\*\*/gi, '<b>$1</b>') // bold text|| markdown e.g **Here is an example of bold text**
      .replace(/--(.*?)--/gi, '<p>$1</p>') // paragraph text|| markdown e.g --Here is an example of paragraph tex--
      .replace(/\^\^(.*?)\^\^/gi, `<section class="${containerName}__midQuote">“$1”</section>`) // section text|| markdown e.g ^^ Here is an example of section text ^^
      .replace(/\*(.*)\*/i, '<i>$1</i>') // italic text || markdown e.g _This is an example of a line of text rendered in italics_
      .replace(/\[(.*?)\]\((.*?)\)/gi, "<a href='$2'>$1</a>") // <a> link tag || markdown e.g [link here](https//:www.money.co.uk)
      .replace(/\/n/gi, '<br />')
      .replace(/^```stats(.*?)stats```/i, Statsmodule),
  )

  return toHTML.join('')
}
